import { useQuery } from "@tanstack/react-query";
import { ListCatalogsQueryFilters, UseListCatalogsQueryOptions } from "./types";
import { getCatalogsService } from "./service";

export const listCatalogsQueryKey = ["plan_admin"];

export function useListCatalogsQuery(
  filters?: ListCatalogsQueryFilters,
  options?: UseListCatalogsQueryOptions
) {

  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listCatalogsQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getCatalogsService(filters),
    ...options,
  });
}
